export default __webpack_public_path__ + "static/media/single_panel.ddb161ee.svg";